<template>
  <div>
    <template v-if="error">
      <header id="navigation" class="py-2">
        <div class="headerWrap px-3 px-md-0">
          <div class="row justify-content-between align-items-center">
            <div class="col-auto d-flex align-items-center header__logo">
              <div class="d-flex align-items-center header__logo__link">
                <img
                  alt="PCLogo"
                  width="60px"
                  height="60px"
                  class="phoenix-logo"
                  src="@/assets/img/logos/PCLogoHeader.png"
                />
              </div>
              <div class="row">
                <div class="col-12">
                  <img
                    alt="PLCnextStore"
                    class="phoenix-logo mx-3"
                    height="20px"
                    src="@/assets/img/logos/PLCnextStore.svg"
                  /><br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="mainWrap mt-5">
        <div class="row mb-3">
          <div class="col-12">
            <h1>An error occurred</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h3>{{ error?.message }}</h3>
            <p>Info: {{ errorMessage }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <!-- leaving a real link here instead of StoreLink component in case of error -->
            <ul>
              <li><a href="/">Home</a></li>
              <li>
                <a
                  href=""
                  role="button"
                  tabindex="0"
                  @click.prevent="reloadPage"
                  @keydown.enter="reloadPage"
                  >Reload Page</a
                >
              </li>
              <li><a href="/support">Support</a></li>
            </ul>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <slot />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { useNuxtApp } from "#app";
import { onErrorCaptured, ref } from "vue";
import { logJavascriptError } from "@/model/api/pLCnextStoreFrontendAPI";

const error = ref<Error | null>(null);
const errorMessage = ref("");

const nuxtApp = useNuxtApp();

const reloadPage = () => {
  window.location.reload();
};

onMounted(() => {
  console.debug("ErrorBoundary mounted");
});

onErrorCaptured((err: unknown, instance, info) => {
  console.error(err);
  console.info(info);

  // Usage in your error handler
  if (err instanceof Error) {
    error.value = err;
    errorMessage.value = info;

    logJavascriptError({
      error: err.message,
      stack: err.stack ?? "",
    })
      .then((response) => {
        console.debug(response);
        console.debug("Error logged successfully");
      })
      .catch((error) => console.error("Error logging:", error));
  } else {
    const errorObj = new Error(String(err));
    error.value = errorObj;
    errorMessage.value = info;

    logJavascriptError({
      error: errorObj.message,
      stack: errorObj.stack ?? "",
    })
      .then((response) => {
        console.debug(response);
        console.debug("Error logged successfully");
      })
      .catch((error) => console.error("Error logging:", error));
  }

  // Nuxt 4 way to show error page
  nuxtApp.callHook("app:error", {
    statusCode: 500,
    message: (err as Error).message || "Unknown error",
  });

  // Prevent further propagation
  return false;
});
</script>
<style lang="scss" scoped>
@use "@/sass/variables.scss" as *;
#navigation {
  background-color: #000;
  border-bottom: 2px solid $gray-700;
}

header {
  .headerWrap {
    width: 100%;
    margin: 0 auto;
    max-width: 100%;
    // Ensure the container handles the negative margins of the inner .row
    // overflow-x: clip; // Prevents negative margins of child rows from causing scrollbars

    @media (min-width: 768px) {
      width: 85%;
    }
    @media (min-width: 1200px) {
      width: 66.6666667%;
    }
  }
  .h5-white {
    color: $gray-100;
  }
}

.header__nav,
.header__logo {
  height: 60px;
}

.header__logo__link {
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
}
</style>
